import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useInViewReveal } from "@/hooks/useInViewReveal";
import { appUrls } from "@/utilities/appUrls";
import appMockup from "@/assets/Img/app-mockup-transactions.png";

export const LevelUpSection = () => {
  const [t] = useTranslation("homeowners");
  const { ref: sectionRef, hasRevealed } = useInViewReveal({ threshold: 0.15 });

  return (
    <section
      ref={sectionRef}
      className="w-full bg-[#f6f5f2] px-6 sm:px-12 lg:px-24 pb-16 lg:pb-32"
    >
      {/* Wrapper — the image is in flow so it sets the full height */}
      <div
        className={classNames(
          "relative transition-all duration-[280ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)]",
          {
            "opacity-100 translate-y-0": hasRevealed,
            "opacity-0 translate-y-[12px]": !hasRevealed,
          }
        )}
      >
        {/* Green background — decorative, covers ~60% bottom */}
        <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[60%] bg-[#e3f1ea] rounded-[48px]" />

        {/* Content row */}
        <div className="relative flex flex-col lg:flex-row items-center gap-8 lg:gap-12 lg:px-12">
          {/* Left — Text + CTA, aligned to the bottom (inside green area) */}
          <div className="flex flex-col gap-8 lg:gap-10 lg:w-[50%] px-6 sm:px-8">
            <p className="font-minion text-homeowners-headline leading-none text-[clamp(1.375rem,0.8rem+2.4vw,3.75rem)]">
              {t("LevelUp.TitleLine1")}
              <br />
              {t("LevelUp.TitleLine2")}
            </p>
            <a
              href={appUrls.signUp}
              className="w-fit bg-homeowners-purple text-white font-montserrat text-[clamp(0.875rem,0.7rem+0.5vw,1.5rem)] px-10 lg:px-14 py-4 lg:py-6 rounded-xl transition-all duration-[180ms] [transition-timing-function:cubic-bezier(0.4,0,0.2,1)] hover:brightness-[0.94] hover:-translate-y-[2px] hover:shadow-lg active:translate-y-0"
            >
              {t("LevelUp.Cta")}
            </a>
          </div>

          {/* Right — App mockup, in normal flow, drives the section height */}
          <div className="lg:w-[40%] flex-shrink-0">
            <img
              src={appMockup}
              alt="Sendola transactions dashboard"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
